import React, { useEffect } from "react";
import EntityReportBlock from "./entityBlock";
import { ReportingPeriodSelector } from "AppSrc/company/report/reportingPeriodSelector";
import { connect } from "react-redux";
import Im from "traec/immutable";
import { BSBtn } from "traec-react/utils/bootstrap";
import Traec from "traec";
import Swal from "sweetalert2";
import { alertSuccess } from "traec-react/utils/sweetalert";

const CompanyReportTitle = props => {
  if (!props.company) {
    return null;
  }
  let name = props.company.get("name");
  return <h3>Generate Indicator Report for {name}</h3>;
};

export const CompanyReport = props => {
  const [state, setState] = React.useState({
    company: Im.Map(),
    configDict: props.configDict,
    reportingPeriods: Im.Map(),
    dates: {}
  });

  useEffect(() => {
    Traec.fetchRequiredFor({
      props,
      requiredFetches: [new Traec.Fetch("company", "read"), new Traec.Fetch("company_indicator", "list")]
    });
  });

  const handleDateChange = (value, name) => {
    let dates = state.configDict.get("dates") || Traec.Im.Map();
    dates = dates.set(name, value);
    setState({ configDict: state.configDict.set("dates", dates) });
  };

  const setConfigInPath = (path, value) => {
    //console.log("Setting Config in Path", path, Traec.Im.fromJS(value).toJS());
    value = value.configDict || value;
    let subConfigDict = state.configDict.getInPath(path) || Traec.Im.Map();
    subConfigDict = subConfigDict.merge(value);
    let configDict = state.configDict.setInPath(path, subConfigDict);
    setState({ configDict });
  };

  return (
    <div className="container-fluid">
      <CompanyReportTitle company={props.company} />

      <ReportingPeriodSelector
        fromDate={props.configDict.getInPath("dates.fromDate")}
        toDate={props.configDict.getInPath("dates.toDate")}
        handleDateChange={handleDateChange}
      />

      <EntityReportBlock
        configPath="master"
        setConfig={setConfigInPath}
        configDict={state.configDict.get("master") || Traec.Im.Map()}
        indent={0}
        companyId={props.companyId}
        includeSubElements={true}
      />

      <hr />
      <SaveButton companyId={props.companyId} configDict={state.configDict} />
      <DownloadButton companyId={props.companyId} configDict={state.configDict} />
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { companyId } = Traec.utils.getFullIds(state, ownProps.match.params);
  let company = state.getInPath(`entities.companies.byId.${companyId}`);
  let configDict = company.getInPath(`meta_json.report_config`) || Traec.Im.Map();
  let projects = company ? company.get("projects") : Im.Map();
  let indicators = company ? state.getInPath(`entities.companyObjects.byId.${companyId}.indicators`) : Im.Map();
  return { companyId, configDict, company, projects, indicators };
};

export default connect(mapStateToProps)(CompanyReport);

const SaveButton = props => {
  const onClick = () => {
    let { companyId, configDict } = props;

    let data = configDict ? configDict.toJS() : {};
    //console.log("Saving report config data", data);

    let fetch = new Traec.Fetch("company", "patch", { companyId });
    fetch.updateFetchParams({
      body: {
        meta_json: {
          report_config: configDict
        }
      },
      postSuccessHook: () =>
        alertSuccess({
          text: "Report configuration saved.",
          onConfirm: () => {
            location.reload();
          }
        })
    });
    fetch.dispatch();
  };

  return <BSBtn text={"Save Config"} onClick={e => onClick(e)} extra_className={"ml-1 mr-1 pl-1 pr-1"} />;
};

const DownloadButton = props => {
  const onClick = () => {
    let { companyId, configDict } = props;

    let data = configDict ? configDict.toJS() : {};

    let fetch = new Traec.Fetch("company_dispatch", "post", { companyId });
    fetch.updateFetchParams({
      body: {
        type: "ASO_RSSB_PDF",
        payload: data
      }
    });
    Swal.queue([
      {
        title: "Compiling Report",
        confirmButtonText: "Download Report",
        html: `<p>This may take several minutes depending on the amount of indicators and metrics.</p><p>Please be patient.</p>`,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return fetch
            .rawFetch({ updateBody: true })
            .then(response => {
              if (response.status == 500) {
                return;
              }
              if (response) return response.blob();
            })
            .then(data => {
              let blobUrl = window.URL.createObjectURL(data);
              Swal.insertQueueStep({
                showConfirmButton: false,
                showCancelButton: false,
                title: "Download ready",
                html: `<p>Click here to download</p><a class="btn btn-primary" href="${blobUrl}" download="REPORT-${companyId.substring(
                  0,
                  8
                )}.pdf">Download</a>`
              });
            })
            .catch(err => {
              console.log(err);
              Swal.insertQueueStep({
                type: "error",
                title: "Error",
                text: "There was an error compiling your results.  Please contact support if the problem persists."
              });
            });
        }
      }
    ]);

    //console.log("DATA", data);
  };

  return <BSBtn text={"Download Report"} extra_className={"ml-1 mr-1 pl-1 pr-1"} onClick={e => onClick(e)} />;
};
